import React, { ChangeEvent, Component } from 'react'
import InputLabel from './InputLabel'

interface TextareaProps {
  name: string
  value: string
  className?: string
  label?: string
  placeholder?: string
  rows?: number
  onChange: (name: string, value: string) => void
}

export default class Textarea extends Component<TextareaProps> {
  constructor (props: TextareaProps) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  get className () {
    const base = 'input-default py-1 h-[inherit]'
    return `${base} ${this.props.className}`
  }

  handleChange (event: ChangeEvent<HTMLTextAreaElement>) {
    const { name, value } = event.target
    this.props.onChange(name, value)
  }

  render () {
    return (
      <div>
        <InputLabel text={this.props.label} />
        <textarea
          className={this.className}
          name={this.props.name}
          value={this.props.value}
          placeholder={this.props.placeholder}
          rows={this.props.rows}
          onChange={this.handleChange} />
      </div>
    )
  }
}
